 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main~d0ae3f07": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + chunkId + "." + {"npm.gsap~9c333ef2":"e07a591383e23edc4160","npm.slugify~64aae0a7":"62573eec81244844fbad","page-about~page-artist~page-photo-exhibition~page-photo-exhibition-artists~page-program~page-special~aaa96f0b":"296260ec27a378a3f8bd","page-about~page-artist~page-photo-exhibition~page-special-project~page-video-exhibition~24ce8d83":"8e0539271c65342e8617","page-artist~page-home~page-photo-exhibition~e9771718":"c6ba5faa1cbccbd0ae04","page-about~page-artist~page-special-project~9ebe54af":"7b9b87e9770b65e18727","page-artist~page-special-project~ff5b6f86":"2c331973c72a43bf6bf4","page-artist~f71cff67":"12a43c6cace763f9713c","npm.plyr~0daa865e":"d4336176e9654e467eb5","npm.vue-plyr~b8937962":"7740c27955e07fb67340","npm.get-video-id~28f26eec":"35d2898a588e58974a25","npm.get-src~ed2eae31":"d81d4e028edcf8b2114a","page-program~page-video-exhibition~af100167":"8bbeda80262f5bb04894","page-video-exhibition~f71cff67":"68063a1e0a8492d4c2d5","npm.iconfu~19a20d81":"bf57238126e46c37a41f","page-photo-exhibition~page-special-project~f71cff67":"5b4c0973ce84ab100628","page-about~page-special-project~15e716ee":"d3f556f190dbf27acd20","page-special-project~f71cff67":"754504a6665276ee931f","page-photo-exhibition~page-photo-exhibition-artists~12a00591":"c2381d682285cb810ba8","page-photo-exhibition~f71cff67":"5bce1eeb171ddb441f91","page-photo-exhibition-artists~page-special-project-artists~249e2e54":"4ec789c6d93dbea0c7b6","page-special-project-artists~b07b7304":"b079b247d13ed1aff5c8","page-photo-exhibition-artists~decc617d":"305d38372b92637d2702","page-about~f71cff67":"b7f5b1b26380024a9f76","page-home~page-program~fdc8287b":"60f11853505691896f96","page-home~f71cff67":"27a720fb5ca641f6cfdb","page-program~f71cff67":"d9c1cb0951c928fd5001","page-live-event-player~b07b7304":"6a7d1b96d5ba83900fd6","page-tailored-creativity~b41b5568":"197c88930d649737c1d3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.lodash~38a85cf5","npm.vuetify~7a09b6f7","npm.vuetify-loader~30af36f2","npm.core-js~41983590","npm.aws-sdk~a8b4667e","npm.axios~b9b6cea2","npm.babel~113cc294","npm.aws-amplify~8a129e59","npm.graphql~191e5755","npm.amazon-cognito-identity-js~1e0217f9","npm.aws-crypto~a99e5185","npm.crypto-js~0c39ca8d","npm.uuid~b160b3e3","npm.querystring-es3~259b8229","npm.webpack~ba46a19e","npm.monogrid~c239a5c0","npm.apollo-link-state~aa7da406","npm.css-loader~6aded061","npm.graphql-anywhere~0eef080e","npm.node-libs-browser~591bd453","npm.optimism~e5da4047","npm.symbol-observable~6e20a0c1","npm.url~f0eea272","npm.vue-style-loader~e7643cb0","npm.zen-observable~7333b33f","npm.wry~772afece","npm.apollo-cache-inmemory~3d3f419c","npm.apollo-cache~ec16e518","npm.apollo-client~d00b6b88","npm.apollo-link-batch-http~c1df0dbb","npm.apollo-link-batch~f1c6b407","npm.apollo-link-error~a34b6b60","npm.apollo-link-http-common~8a9e1bde","npm.apollo-link~1e28f5e6","npm.apollo-utilities~3fba4b84","npm.vue-apollo~41d41d87","npm.base64-js~542cf665","npm.console-polyfill~09cfb864","npm.deepmerge~11c11368","npm.fast-json-stable-stringify~671c6240","npm.graphql-tag~e5721fa3","npm.ieee754~2f106160","npm.intersection-observer~79123a75","npm.isarray~93ecf554","npm.js-cookie~6f943d3f","npm.process~e979afec","npm.regenerator-runtime~84d0a99a","npm.ts-invariant~8e2c0eb2","npm.tslib~0353a882","npm.vue-axios~42e5ce89","npm.vue-event-handler~958acfd8","npm.vue-gettext~733cbc2c","npm.vue-gtm~3a225059","npm.vue-loader~3d84837a","npm.vue-meta~1c83d4ba","npm.vue-router~4d830cd8","npm.vue~0dd8155b","npm.whatwg-fetch~0d45f70b","npm.zen-observable-ts~26b613ba"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
